import React from 'react';
import '../member_dashboard/member_dashboard_page.css';
import { ChevronRight, CheckCircle, Smartphone, Mail, MapPin, Briefcase, Award,  CircleX} from 'lucide-react';
import { useEffect, useState } from 'react';
import { auth, db } from '../../../firebase'; // Adjust path as needed
import { doc, getDoc, updateDoc, serverTimestamp, collection, addDoc } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import avatar from "../../../parm_assets/membership/user.png"
import { Link } from 'react-router-dom';
import axios from 'axios';
import { FaCamera } from 'react-icons/fa';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';

const MemberDashboard = () => {
  const [memberData, setMemberData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [uploading, setUploading] = useState(false);

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      navigate('/login-parm');
    } catch (error) {
      console.error("Error signing out:", error);
      alert("Failed to sign out. Please try again.");
    }
  };

  const isVeteran = () => {
    if (!memberData?.joinedDate || memberData?.status !== "verified") return false;
    const joinedDate = memberData?.joinedDate.toDate(); 
    const twoYearsAgo = new Date();
    twoYearsAgo.setFullYear(twoYearsAgo.getFullYear() - 2);
    return joinedDate <= twoYearsAgo;
  };

    const isLifetime = memberData?.memberType === 'Lifetime Members' || memberData?.memberType === 'Ahli Seumur Hidup' || memberData?.memberType === 'Corporate Members' || memberData?.memberType === 'Ahli Korporat';



  // =========================================================================
  // HOOK 1: Listen for Auth State & Fetch Baseline Profile (Your Original Hook)
  // =========================================================================
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const docRef = doc(db, "registrations", user.uid);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            setMemberData(docSnap.data());
          } else {
            console.log("No such member record!");
          }
        } catch (error) {
          console.error("Error fetching member data:", error);
        }
      } else {
        navigate('/login-parm');
      }
      setLoading(false);
    });

    return () => unsubscribe(); 
  }, [navigate]);

  // =========================================================================
  // HOOK 2: Background API Check using Saved currentBillCode
  // =========================================================================
  useEffect(() => {
    const verifySavedBillCode = async () => {
      // 1. Only run if we have a currentBillCode and the paymentStatus isn't already "Success"
      if (memberData?.currentBillCode && memberData?.paymentStatus?.startsWith("Pending_") && auth.currentUser) {
          try {
            console.log(`📡 Background verifying saved tracking code: ${memberData.currentBillCode}`);

            const secretRef = doc(db, "appSettings", "toyyibpay");
            const secretSnap = await getDoc(secretRef);
            if (!secretSnap.exists()) return;
            
            const { secretKey } = secretSnap.data();

            const formData = new FormData();
            formData.append('billCode', memberData.currentBillCode);

            const response = await axios.post(
              // 'https://dev.toyyibpay.com/index.php/api/getBillTransactions',
              'https://toyyibpay.com/index.php/api/getBillTransactions',
              formData,
              { headers: { 'Content-Type': 'multipart/form-data' } }
            );

            const transaction = response.data?.[0];
            const uid = auth.currentUser.uid;
            const userRef = doc(db, "registrations", uid);
            
            // Extract their current pending context state straight out of the database data model
            const currentPendingState = memberData.paymentStatus; 

            // =========================================================================
            // CASE A: CONFIRMED TRANSACTION SUCCESS ("1")
            // =========================================================================
            if (transaction && transaction.billpaymentStatus === "1") {
              console.log(`🔒 API confirmed payment success for state context: ${currentPendingState}`);

              const applicantEmail = memberData?.email || auth.currentUser?.email;
              const applicantName = memberData?.name || "Applicant";
              const adminEmail = "malaysiaarborist@gmail.com";

              // 🟢 BRANCH 1: Miscellaneous Payment
              if (currentPendingState === "Pending_Other") {
                await updateDoc(userRef, {
                  lastPaymentDate: serverTimestamp(),
                  paymentStatus: "Success_Other" // 👈 Unique persistent success value
                });

                setMemberData(prev => ({ ...prev, paymentStatus: "Success_Other" }));
          
                      // try {
              //   await addDoc(collection(db, "mail"), {
              //     to: [applicantEmail, adminEmail],
              //     from: adminEmail,
              //     message: {
              //       subject: `PArM Payment Received - SUCCESSFUL`,
              //       html: `
              //         <div style="font-family: Arial, sans-serif; padding: 20px; color: #333;">
              //           <h3 style="color: #2e7d32;">Payment Received</h3>
              //           <p>Hello <strong>${applicantName}</strong>,</p>
              //           <p>Your custom miscellaneous transaction has been processed successfully by PArM.</p>
              //           <p><strong>Transaction Tracking Reference:</strong> ${memberData.currentBillCode}</p>
              //           <br />
              //           <hr style="border: none; border-top: 1px solid #eee;" />
              //           <p style="font-size: 0.85rem; color: #777;">Automated Transaction Node - Malaysia Society of Arborist (PArM).</p>
              //         </div>
              //       `
              //     }
              //   });
              //   console.log("📨 Miscellaneous payment email dispatched successfully.");
              // } catch (mailErr) {
              //   console.error("Failed to queue misc payment email:", mailErr);
              // }

            // =========================================================================
            // BRANCH 2: MEMBERSHIP BALANCES FLOW (Registration, Renewal, Tunggakan)
            // =========================================================================
            } else {
              console.log("⏳ Running standard membership expiry calculation engine...");

              let yearsPaid = 1;
              const urlParams = new URLSearchParams(window.location.search);
              if (urlParams.has('years')) {
                yearsPaid = Number(urlParams.get('years')) || 1;
              }

              // 1. Default fallback to current year (for new registrations)
              let baseYear = new Date().getFullYear();

              // 2. 🟢 BOTH Renewal & Tunggakan read strictly from historical DB expiry
              if ((currentPendingState === "Pending_Renewal" || currentPendingState === "Pending_Tunggakan") && memberData?.membershipExpiry) {
                
                const pastExpiryDate = memberData.membershipExpiry?.seconds 
                  ? new Date(memberData.membershipExpiry.seconds * 1000) 
                  : new Date(memberData.membershipExpiry);

                // Extract the historical expiration year in UTC
                const historicalYear = pastExpiryDate.getUTCFullYear();

                // Strictly set baseYear to historical membership expiry year
                baseYear = historicalYear;
              }

              // 3. Compute target expiry year
              let targetExpiryYear = baseYear + yearsPaid;

              if (yearsPaid === 99) { 
                targetExpiryYear = baseYear + 50; 
              }

              // 4. 🟢 Lock date to 31 December at 12:00:00 UTC
              // 12:00 UTC = 8:00 PM Malaysia Time (GMT+8) on 31 Dec.
              // This prevents timezone conversions from rolling over to 1 Jan.
              const targetExpiryDate = new Date(Date.UTC(targetExpiryYear, 11, 31, 12, 0, 0));

              // ISO string ready to save to Firebase
              const structuredExpiryString = targetExpiryDate.toISOString();

              console.log(`✅ Calculated Expiry Date: 31 Dec ${targetExpiryYear} (${structuredExpiryString})`);

              const finalSuccessStatus = currentPendingState === "Pending_Registration" ? "Success_Registration" : currentPendingState === "Pending_Tunggakan" ? "Success_Tunggakan" : "Success_Renewal";

              if (currentPendingState === "Pending_Registration") {
              // 🟢 3. Trigger Core Membership Confirmation Email
              try {
                await addDoc(collection(db, "mail"), {
                  to: [applicantEmail, adminEmail], 
                  from: adminEmail,
                  message: {
                    subject: `PArM Membership Payment - SUCCESSFUL`,
                    html: `
                      <div style="font-family: Arial, sans-serif; padding: 20px; color: #333;">
                        <h3 style="color: #2e7d32;">Payment Received Successfully</h3>
                        <p>Hello <strong>${applicantName}</strong>,</p>
                        <p>Your transaction has been securely processed. Welcome to the Malaysia Society of Arborist (PArM).</p>
                        <p>Please give our admin team time to update your custom PArM IDs. You can check your PArM No in your member dashboard from time to time.</p>
                        <br />
                        <a href="https://www.parm.com.my/login-parm" style="background-color: #2e7d32; color: white; padding: 10px 20px; text-decoration: none; border-radius: 50px; display: inline-block;">
                          Open Member Dashboard Portal
                        </a>
                        <br /><br />
                        <hr style="border: none; border-top: 1px solid #eee;" />
                        <p style="font-size: 0.85rem; color: #777;">This is an automated notification from the Malaysia Society of Arborist (PArM).</p>
                      </div>
                    `
                  }
                });
                console.log("📨 Membership lifecycle tracking email dispatched successfully.");
              } catch (mailErr) {
                console.error("System failed to log email document transaction:", mailErr);
              }
            }
            
              // 3. Commit update values directly to database document references
              await updateDoc(userRef, {
                status: "verified",
                membershipExpiry: targetExpiryDate, // Saves natively as a Firebase Timestamp type
                lastPaymentDate: serverTimestamp(),
                paymentStatus: finalSuccessStatus
              });

              // 4. Update local state engines cleanly to keep UI view frames running seamlessly
              setMemberData(prev => ({
                ...prev,
                status: "verified",
                membershipExpiry: structuredExpiryString, // Kept as ISO String format for UI component parser inputs
                paymentStatus: finalSuccessStatus
              }));

            }
          } else {
            console.log("❌ Transaction reported as failed by checkout gateway.");

          let finalFailedStatus = "Failed_Registration";
          if (currentPendingState === "Pending_Renewal") finalFailedStatus = "Failed_Renewal";
          if (currentPendingState === "Pending_Tunggakan") finalFailedStatus = "Failed_Tunggakan";
          if (currentPendingState === "Pending_Other") finalFailedStatus = "Failed_Other";

          // 🟢 FIX 1: Clear currentBillCode so this verification block won't re-trigger on re-renders
          await updateDoc(userRef, { 
            paymentStatus: finalFailedStatus,
            currentBillCode: null // Clears the active bill tracking ID
          });

          // 🟢 FIX 2: Clear local state as well to sync UI immediately
          setMemberData(prev => ({ 
            ...prev, 
            paymentStatus: finalFailedStatus,
            currentBillCode: null 
          }));

          const applicantEmail = memberData?.email || auth.currentUser?.email;
          const applicantName = memberData?.name || "Applicant";
          const adminEmail = "malaysiaarborist@gmail.com";

          try {
            // 🟢 Email will now only send ONCE because currentBillCode is cleared
            await addDoc(collection(db, "mail"), {
              to: [applicantEmail, adminEmail], 
              from: adminEmail,
              message: {
                subject: `PArM Membership Payment - FAILED`,
                html: `
                  <div style="font-family: Arial, sans-serif; padding: 20px; color: #333;">
                    <h3 style="color: #d32f2f;">Your latest payment was unsuccessful</h3>
                    <p>Hello <strong>${applicantName}</strong>,</p>
                    <p>Please try making another payment or contact PArM Admin for confirmation.</p>
                    <br />
                    <a href="https://www.parm.com.my/login-parm" style="background-color: #2e7d32; color: white; padding: 10px 20px; text-decoration: none; border-radius: 50px; display: inline-block;">
                      Open Dashboard Portal
                    </a>
                    <br /><br />
                    <hr style="border: none; border-top: 1px solid #eee;" />
                    <p style="font-size: 0.85rem; color: #777;">This is an automated notification from the Malaysia Society of Arborist (PArM).</p>
                  </div>
                `
              }
            });
            console.log("📨 Failure notification email dispatched ONCE.");
        
          } catch (mailErr) {
            console.error("System failed to insert document to trigger email extension module:", mailErr);
          }
        }

        } catch (error) {
          console.error("Error verifying payment transaction status in background:", error);
        }
      }
    };

    verifySavedBillCode();
  }, [memberData?.currentBillCode, memberData?.paymentStatus]);

  //upload profile picture
  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // 1. File Type Validation Guard
    if (!file.type.startsWith('image/')) {
      return alert('Please upload a valid image file (PNG/JPG/JPEG).');
    }

    // 2. Size Limit Guard (e.g., 2MB)
    if (file.size > 2 * 1024 * 1024) {
      return alert('Image size must be smaller than 2MB.');
    }

    setUploading(true);

    try {
      const user = auth.currentUser;
      if (!user) throw new Error("No authenticated session found.");

      // 3. Initialize Native Firebase Storage
      const storage = getStorage();
      
      // Create a specific reference path: profile_pictures/USER_UID.jpg
      // Using the exact extension type from the uploaded file
      const fileExtension = file.name.split('.').pop();
      const storageRef = ref(storage, `profile_pictures/${user.uid}.${fileExtension}`);

      console.log("📡 Uploading asset directly to Firebase Storage...");
      
      // 4. Upload raw file bytes stream to Firebase Storage bucket
      await uploadBytes(storageRef, file);

      // 5. Retrieve the secure, authenticated public download token link
      const secureUrl = await getDownloadURL(storageRef);
      console.log("🔗 Secure download URL retrieved:", secureUrl);

      // 6. Update Firestore registrations document tracking mapping
      const userRef = doc(db, "registrations", user.uid);
      await updateDoc(userRef, {
        passportUrl: secureUrl
      });

      // 7. Update parent or dashboard state context arrays immediately
      if (setMemberData) {
        setMemberData(prev => ({
          ...prev,
          passportUrl: secureUrl
        }));
      }

      alert("Profile photo updated successfully!");

    } catch (error) {
      console.error("Firebase native upload transaction failed:", error);
      alert("Failed to upload image: " + error.message);
    } finally {
      setUploading(false);
    }
  };

  // const formatExpiryDate = (dateValue) => {
  //     if (!dateValue) return "N/A";

  //     let dateObj;

  //     // 1. Check if it's a Firestore Timestamp
  //     if (dateValue.seconds) {
  //       dateObj = new Date(dateValue.seconds * 1000);
  //     } else {
  //       // 2. Otherwise parse it as a string or Date object
  //       dateObj = new Date(dateValue);
  //     }

  //     // Check if the date parsing was successful
  //     if (isNaN(dateObj.getTime())) {
  //       return String(dateValue); // Return raw string if parsing fails
  //     }

  //     // 3. Format to: "31 December 2027"
  //     return dateObj.toLocaleDateString('en-GB', {
  //       day: 'numeric',
  //       month: 'long',
  //       year: 'numeric'
  //     });
  //   };

    // 1. 🟢 Safe Date Formatter for Firebase Timestamps
const formatExpiryDate = (dateValue) => {
    if (!dateValue) return "N/A";

    let dateObj;

    // Check if it's a native Firebase Timestamp
    if (dateValue && typeof dateValue === 'object' && 'seconds' in dateValue) {
      dateObj = new Date(dateValue.seconds * 1000);
    } else {
      // Fallback if it arrived as a string representation
      const cleaned = String(dateValue).replace(/\sat\s/i, ' ');
      dateObj = new Date(cleaned);
    }

    if (isNaN(dateObj.getTime())) return String(dateValue);

    // 🟢 FIXED: Force toLocaleDateString to evaluate the date using the UTC timezone
    return dateObj.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      timeZone: 'UTC' // This forces the browser to ignore the local +8 hours shift
    });
  };

// 2. 🟢 Safe Arrears Calculator for Firebase Timestamps
const calculateTunggakkan = (expiryValue, memberType) => {
    if (!expiryValue || !memberType) return 0;

    const feeMapping = {
      'Professional Members': 100, 'Ordinary Members': 100, 'Corporate Members': 0,
      'Veteran Members': 25, 'Lifetime Members': 0, 'Student Members': 25,
      'Professional': 100, 'Ordinary': 100, 'Corporate': 0, 'Veteran': 25,
      'Lifetime': 0, 'Student': 25,
      
      'Ahli Profesional': 100, 'Ahli Biasa': 100, 'Ahli Korporat': 0,
      'Ahli Veteran': 25, 'Ahli Seumur Hidup': 0, 'Ahli Pelajar': 25,
      'Profesional': 100, 'Biasa': 100, 'Korporat': 0, 'Veteran': 25,
      'Seumur Hidup': 0, 'Pelajar': 25,
    };

    const annualFee = feeMapping[memberType] !== undefined ? feeMapping[memberType] : 100;
    if (annualFee === 0) return 0;

    let expiryDate;

    // Check if it's a native Firebase Timestamp
    if (expiryValue && typeof expiryValue === 'object' && 'seconds' in expiryValue) {
      expiryDate = new Date(expiryValue.seconds * 1000);
    } else {
      // Fallback if it arrived as a string representation
      const cleaned = String(expiryValue).replace(/\sat\s/i, ' ');
      expiryDate = new Date(cleaned);
    }

    if (isNaN(expiryDate.getTime())) return 0;

    const currentDate = new Date();
    if (expiryDate >= currentDate) return 0;

    const expiryYear = expiryDate.getFullYear(); // Will extract 2025
    const currentYear = currentDate.getFullYear(); // Will extract 2026
    
    const yearsOwed = currentYear - expiryYear; // 2026 - 2025 = 1 year

    return yearsOwed > 0 ? yearsOwed * annualFee : 0;
  };

  const feeMapping = {
    'Professional Members': 100, 'Ordinary Members': 100, 'Corporate Members': 0,
    'Veteran Members': 25, 'Lifetime Members': 0, 'Student Members': 25,
    'Professional': 100, 'Ordinary': 100, 'Corporate': 0, 'Veteran': 25,
    'Lifetime': 0, 'Student': 25,
    'Ahli Profesional': 100, 'Ahli Biasa': 100, 'Ahli Korporat': 0,
    'Ahli Veteran': 25, 'Ahli Seumur Hidup': 0, 'Ahli Pelajar': 25,
    'Profesional': 100, 'Biasa': 100, 'Korporat': 0, 'Veteran': 25,
    'Seumur Hidup': 0, 'Pelajar': 25,
  };
  const baseFee = feeMapping[memberData?.memberType] !== undefined ? feeMapping[memberData?.memberType] : 100;

  // 2. Calculate total tunggakkan using your existing function
  const totalTunggakkan = calculateTunggakkan(memberData?.membershipExpiry, memberData?.memberType);

  // 3. Determine years owed: if baseFee is 0 (Lifetime/Corporate), years owed is automatically 0
  const yearsOwed = baseFee > 0 ? totalTunggakkan / baseFee : 0;

  // 4. Structural Active check: Must be verified AND arrears cannot be more than 3 years
  const isEffectivelyActive = memberData?.status === "verified" && yearsOwed <= 3;

  if (loading) return <p>Loading your profile...</p>;

  return (
    <div className="dashboard-container">
      {/* Main Profile Card */}
      <div className="profile-main-card">
        <div className="profile-grid">
          
          {/* Left: Contact Info */}
          <div className="info-column card-bg">
            <h3>Information</h3>
            <ul className="info-list">
              <li><Briefcase size={20} /> {memberData?.memberType}</li>
              <li><Award size={20} /> {memberData?.experienceType}</li>
              <li><MapPin size={20} /> {memberData?.companyAdd}</li>
              <li><Smartphone size={20} /> {memberData?.phone}</li>
              <li><Mail size={20} /> {memberData?.email}</li>
            </ul>
          </div>

          {/* Center: Status Grid */}
          <div className="status-column">
          <div className="id-badge">
            <span className="id-icon">📇 </span>
            {/* Use !memberData.parmNo to check for null, undefined, or empty string */}
            <h2>{!memberData?.parmNo ? "!Please Complete Registration" : memberData?.parmNo}</h2>
          </div>
          
          {/* <div className="status-row"> */}
            {/* <div className="status-box card-bg">
              <div className="status-header">
                <span className="status-title">{memberData?.parmNo ? "Active" : "Not Active"}</span>
                {!memberData?.parmNo ? (
                  <CircleX size={20} className="status-icon inactive" />
                ) : (
                  <CheckCircle size={20} className="status-icon active-membership" />
                )}
              </div>
              <p>Membership Status</p>
            </div> */}

              <div className="status-row">
                {/* <div className="status-box card-bg">
                  <div className="status-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    
                    <div className="status-title-group" style={{ display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
                      <span className="status-title">
                        {memberData?.status === "verified" ? "Active" : "Not Active"}
                      </span>
                      
                      {memberData && memberData.status === "verified" && memberData.membershipExpiry && (
                        <>
                          <span className="status-active-date" style={{ fontSize: '0.8rem', color: '#2e7d32', marginTop: '4px', fontWeight: '600' }}>
                            Active until: {formatExpiryDate(memberData.membershipExpiry)}
                          </span>

                          {calculateTunggakkan(memberData.membershipExpiry, memberData.memberType) > 0 && (
                            <span className="status-tunggakkan" style={{ fontSize: '0.8rem', color: '#d32f2f', marginTop: '2px', fontWeight: '700' }}>
                              Overdue: RM {calculateTunggakkan(memberData.membershipExpiry, memberData.memberType)}
                            </span>
                          )}
                        </>
                      )}
                    </div>

                    {memberData?.status !== "verified" ? (
                      <CircleX size={20} className="status-icon inactive" />
                    ) : (
                      <CheckCircle size={20} className="status-icon active-membership" />
                    )}
                  </div>
                  <p style={{ marginTop: '12px' }}>Membership Status</p>
                </div> */}

                <div className="status-box card-bg">
                  <div className="status-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    
                    <div className="status-title-group" style={{ display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
                      {/* Main Status Text Indicator */}
                      <span className="status-title">
                        {isEffectivelyActive ? "Active" : "Not Active"}
                      </span>
                      
                      {/* Render Expiry Dates Details */}
                      {memberData?.status === "verified" && memberData?.membershipExpiry && (
                        <>
                          <span className="status-active-date" style={{ fontSize: '0.8rem', color: isEffectivelyActive ? '#2e7d32' : '#64748b', marginTop: '4px', fontWeight: '600' }}>
                            Active until: {formatExpiryDate(memberData.membershipExpiry)}
                          </span>

                          {/* Render Arrears value if they owe any money */}
                          {totalTunggakkan > 0 && (
                            <span className="status-tunggakkan" style={{ fontSize: '0.8rem', color: '#d32f2f', marginTop: '2px', fontWeight: '700' }}>
                              Tunggakkan: RM {totalTunggakkan} 
                              {yearsOwed > 3 && " (Lapsed)"}
                            </span>
                          )}
                        </>
                      )}
                    </div>

                    {!isEffectivelyActive ? (
                      <CircleX size={20} className="status-icon inactive" />
                    ) : (
                      <CheckCircle size={20} className="status-icon active-membership" />
                    )}
                  </div>
                  <p style={{ marginTop: '12px' }}>Membership Status</p>
                </div>
             
            
              <div className="experience-box card-bg">
                <h4>Experience Field</h4>
                <ul>
                  <li>{memberData?.fieldOfWorks}</li>
                  <li>{memberData?.experienceType}</li>
                </ul>
              </div>
            </div>

            <div className="status-row">
              <div className="ceu-box card-bg">
                <span className="ceu-count">00</span>
                <span className="ceu-label">CEU Collected</span>
              </div>
              <div className="certification-box card-bg">
                <h4>Arboriculture experience</h4>
                <ul>
                  <li>{memberData?.experiencePhase}</li>
                  {/* <li>Master in Landscape Architecture (UPM)</li> */}
                </ul>
              </div>
            </div>
          </div>

          {/* Right: Profile Image & Name */}
          <div className="name-column">
            {/* Clickable Image Label Wrapper */}
            <label htmlFor="avatar-upload" className={`profile-img-wrapper ${uploading ? 'upload-processing' : ''}`}>
              <img 
                src={memberData?.passportUrl || avatar} // Fallback avatar asset link string
                alt={memberData?.name || "Member Profile"} 
                className="profile-img"
              />
              
              {/* Hover Camera Graphic Layer */}
              <div className="profile-img-overlay">
                {uploading ? <div className="mini-spinner"></div> : <FaCamera className="camera-icon" />}
              </div>

              {/* Hidden System File Dispatch Native Input */}
              <input 
                type="file" 
                id="avatar-upload" 
                accept="image/*" 
                onChange={handleImageChange} 
                disabled={uploading}
                style={{ display: 'none' }} 
              />
            </label>
            
            <h1 className="profile-name">{memberData?.name}</h1>
          </div>
        </div>
      </div>

      {/* Sidebar / Menu Column */}
      <aside className="dashboard-sidebar">
        <nav className="main-nav">

          <a href="/member-dashboard-parm">
            <button className="nav-btn-dashboard">MAIN <ChevronRight size={16} /></button>
          </a>

          <a href='/update-profile-parm'>
            <button className="nav-btn-dashboard">UPDATE PROFILE <ChevronRight size={16} /></button>
          </a>
          {/* <button className="nav-btn">CEU <ChevronRight size={16} /></button> */}
          {(memberData?.status == "verified") && (
            // <a href = '/membership-payment-parm'>
            <button className="nav-btn-dashboard">PAYMENT <ChevronRight size={16} /></button>
            // </a>
          )}

          {isVeteran() && (
          <a href="/proposer-request-parm">
            <button className="nav-btn-dashboard">
              PROPOSAL REQUESTS
              <ChevronRight size={16} />
            </button>
          </a>
        )}
        
        {memberData?.role == "admin" && (
        <a href= '/admin-parm'>
          <button className="nav-btn-dashboard">ADMIN DASHBOARD <ChevronRight size={16} /></button>
          </a>
        )}

          <button 
            className="nav-signout-btn-dashboard" 
            onClick={handleSignOut}
          >
            SIGN OUT <ChevronRight size={14} />
          </button>
        </nav>

        {/* <div className="action-btns">
          <button className="secondary-btn">Update Profile</button>
          <button 
            className="secondary-btn" 
            onClick={handleSignOut}
          >
            Sign Out <ChevronRight size={14} />
          </button>
        </div> */}

        {(memberData?.parmNo === null || memberData?.parmNo === "" || !memberData?.parmNo) && (
          <a href={memberData?.status === "pending_proposer" ? "/membership-proposer-parm" : "/registration-status-parm"}>
            <button className="registration-status-btn">
              {memberData?.status === "pending_proposer" ? "COMPLETE MEMBER REGISTRATION !" : "VIEW REGISTRATION PROGRESS"}
            </button>
          </a>
        )}
      </aside>
    </div>
  );
};

export default MemberDashboard;